export const selector = ({ places, checkout, appConfiguration }) => ({
  countries: places.countries,
  userData: checkout.requestData,
  localization: appConfiguration.localize
});
